import axios from 'axios';
import { toast } from 'react-toastify';
export const ADD_NEWSPOST_LOADER = 'ADD_NEWSPOST_LOADER';
export const addNewsPostLoader = bool => ({
  type: 'ADD_NEWSPOST_LOADER',
  payload: bool,
});

export const addNewsPostAction = obj => {
  return async dispatch => {
    dispatch(addNewsPostLoader(true));

    let data = JSON.stringify({ ...obj });

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/newPosts/create`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: data,
    };

    axios(config)
      .then(response => {
        dispatch(newsPostData(response.data.data));
        toast.success('News Post Added');
        dispatch(addNewsPostLoader(false));
      })
      .catch(error => {
        toast.error('News Post Not Added');
        dispatch(addNewsPostLoader(false));
      });
  };
};

export const GET_NEWSPOST_LOADER = 'GET_NEWSPOST_LOADER';
export const getNewsPostLoader = bool => ({
  type: 'GET_NEWSPOST_LOADER',
  payload: bool,
});

export const getNewsPostAction = obj => {
  return async dispatch => {
    dispatch(getNewsPostLoader(true));

    let data = JSON.stringify({ ...obj });

    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/newPosts/get`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: data,
    };

    axios(config)
      .then(response => {
        dispatch(newsPostData(response.data.data));

        dispatch(getNewsPostLoader(false));
      })
      .catch(error => {
        dispatch(getNewsPostLoader(false));
      });
  };
};

export const UPDATE_NEWSPOST_LOADER = 'UPDATE_NEWSPOST_LOADER';
export const updateNewsPostLoader = bool => ({
  type: 'UPDATE_NEWSPOST_LOADER',
  payload: bool,
});

export const updateNewsPostAction = (obj, handleEditOk) => {
  return async dispatch => {
    dispatch(updateNewsPostLoader(true));

    let data = JSON.stringify({ title_name: obj.title_name });

    let config = {
      method: 'put',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/newPosts/update/${obj._id}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: data,
    };

    axios(config)
      .then(response => {
        dispatch(newsPostData(response.data.data));

        dispatch(updateNewsPostLoader(false));
        if (handleEditOk) {
          handleEditOk();
        }
        toast.success('News Post Has Been Updated');
      })
      .catch(error => {
        dispatch(updateNewsPostLoader(false));
        toast.error('something went wrong');
      });
  };
};

export const DELETE_NEWSPOST_LOADER = 'DELETE_NEWSPOST_LOADER';
export const deleteNewsPostLoader = bool => ({
  type: 'DELETE_NEWSPOST_LOADER',
  payload: bool,
});

export const deleteNewsPostAction = (obj, handleDeleteOk) => {
  return async dispatch => {
    dispatch(deleteNewsPostLoader(true));

    let config = {
      method: 'delete',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/newPosts/delete/${obj._id}`,
      headers: {
        'Content-Type': 'application/json',
      },
    };

    axios(config)
      .then(response => {
        dispatch(newsPostData(response.data.data));

        dispatch(deleteNewsPostLoader(false));
        if (handleDeleteOk) {
          handleDeleteOk();
        }
        toast.success('News Post Has Been Deleted');
      })
      .catch(error => {
        dispatch(deleteNewsPostLoader(false));
        toast.error('something went wrong');
      });
  };
};

export const NEWS_POST_DATA = 'NEWS_POST_DATA';
export const newsPostData = payload => ({
  type: 'NEWS_POST_DATA',
  payload: payload,
});
